/**
 * @file legal-requisites-blocks.ts
 * @description Блоки HTML из карточки «Реквизиты» для текста юридического
 * документа (phase19; вынесено из LegalDocumentEditPage в phase19.16).
 *
 * Кнопки «Из реквизитов» в редакторе дописывают блок в конец текста.
 * Значения экранируются: реквизиты вводит человек, в документ они попадают
 * как HTML.
 */

import type { LegalProfileDto } from "../api-crm";

interface BankDetails {
  account?: string;
  bik?: string;
  correspondentAccount?: string;
  bankName?: string;
}

/** Банковские реквизиты профиля (поле JSON без схемы). */
function bankOf(p: LegalProfileDto): BankDetails {
  return (p.bankDetails ?? {}) as BankDetails;
}

/** Есть ли у профиля хоть одно банковское поле. */
export function hasBankDetails(p: LegalProfileDto): boolean {
  const b = bankOf(p);
  return !!(b.account || b.bik || b.bankName);
}

/** Экранирование текста реквизитов перед вставкой в HTML документа. */
function esc(s: string | null | undefined): string {
  return (s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

export function sellerBlockHtml(p: LegalProfileDto): string {
  const lines = [
    `<p><strong>${esc(p.legalName)}</strong><br>`,
    `ИНН ${esc(p.inn)}`,
    p.kpp ? `, КПП ${esc(p.kpp)}` : "",
    p.ogrn ? `, ОГРН ${esc(p.ogrn)}` : "",
    `<br>Адрес: ${esc(p.legalAddress)}`,
    p.phone ? `<br>Телефон: ${esc(p.phone)}` : "",
    `</p>`,
  ];
  return `<h2>Реквизиты продавца</h2>${lines.join("")}`;
}

export function bankBlockHtml(p: LegalProfileDto): string {
  const b = bankOf(p);
  const rows = [
    b.bankName ? `Банк: ${esc(b.bankName)}` : "",
    b.account ? `Р/с: ${esc(b.account)}` : "",
    b.correspondentAccount ? `К/с: ${esc(b.correspondentAccount)}` : "",
    b.bik ? `БИК: ${esc(b.bik)}` : "",
  ].filter(Boolean);
  return `<h2>Банковские реквизиты</h2><p>${rows.join("<br>")}</p>`;
}

export function contactsBlockHtml(p: LegalProfileDto): string {
  const rows = [p.phone ? `Телефон: ${esc(p.phone)}` : "", `Адрес: ${esc(p.legalAddress)}`].filter(Boolean);
  return `<h2>Контакты</h2><p>${rows.join("<br>")}</p>`;
}
